/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BaseResponseBoolean,
  BaseResponseUserLoginResponse,
  BaseResponseUserRenewalTokenResponse,
  UserLoginRequest,
} from './data-contracts';
import {ContentType, HttpClient, RequestParams} from './http-client';

export class Auth<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 로그인을 진행합니다. Refresh Token은 Cookie (refreshToken)으로 전달됩니다. 심사가 진행중인 계정은 code로 4000을 반환하고 심사가 거절된 계정은 code로 4001을 반환합니다.
   *
   * @tags Auth
   * @name PostUserLogin
   * @summary 유저 로그인
   * @request POST:/app/auths
   * @secure
   * @response `200` `BaseResponseUserLoginResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  postUserLogin = async (data: UserLoginRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseUserLoginResponse, void>({
      path: `/app/auths`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description Refresh Token을 사용하여 유저의 Token을 갱신합니다.
   *
   * @tags Auth
   * @name PostUserRenewalToken
   * @summary 유저 Token 재발급
   * @request POST:/app/auths/renewal
   * @secure
   * @response `200` `BaseResponseUserRenewalTokenResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  postUserRenewalToken = async (params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseUserRenewalTokenResponse, void>({
      path: `/app/auths/renewal`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 로그아웃을 진행합니다.
   *
   * @tags Auth
   * @name PostUserLogout
   * @summary 유저 로그아웃
   * @request POST:/app/auths/logout
   * @secure
   * @response `200` `BaseResponseBoolean` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  postUserLogout = async (params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseBoolean, void>({
      path: `/app/auths/logout`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };
}
